var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31.999,
    viewBox: "0 0 32 31.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_43322",
    "data-name": "Path 43322",
    d: "M1532,7745.67a16.2,16.2,0,0,0-16,16.4,16.372,16.372,0,0,0,10.94,15.569c.8.146,1.09-.354,1.09-.793,0-.386-.01-1.419-.02-2.786-4.45.98-5.39-2.2-5.39-2.2a4.254,4.254,0,0,0-1.78-2.4c-1.45-1.022.12-1,.12-1a3.381,3.381,0,0,1,2.45,1.69,3.358,3.358,0,0,0,4.66,1.367,3.47,3.47,0,0,1,1.01-2.191c-3.55-.417-7.29-1.826-7.29-8.108a6.4,6.4,0,0,1,1.65-4.4,5.973,5.973,0,0,1,.14-4.341s1.34-.438,4.4,1.68a14.75,14.75,0,0,1,8,0c3.04-2.118,4.38-1.68,4.38-1.68a6.136,6.136,0,0,1,.16,4.341,6.441,6.441,0,0,1,1.64,4.4c0,6.3-3.74,7.691-7.3,8.087a4,4,0,0,1,1.08,3.037c0,2.2-.02,3.965-.02,4.5,0,.428.28.939,1.1.783a16.447,16.447,0,0,0-5.02-31.953Z",
    transform: "translate(-1516 -7745.671)",
    fill: "#92a7ba"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.0135cd36ffc29cc5aed3f47d34c69c9b.svg";
export { ForwardRef as ReactComponent };